import api from '@pray/shared/utils/api';

import type { CreateFeatureFlagInput } from './types';

export const createFeatureFlag = async (data: CreateFeatureFlagInput) => {
  if (!data.flag_id) throw Error('Flag ID is required');
  if (!data.name) throw Error('Name is required');

  const url = '/web/studio/feature-flags';
  const response = await api.executePostRequest(url, data);
  return response.data;
};
